export default __webpack_public_path__ + "static/media/12-3.8f392cb8.jpg";